import {hexToComplimentary} from '@/utils';

const defaultColorPalette = [
  '#5BC0EB',
  '#FDE74C',
  '#9BC53D',
  '#C3423F',
  '#000000',
  '#FFFFFF',
  '#808080',
];

export function createColorPaletteFromBranding(branding) {
  if (!branding || !branding.color_primary || !branding.color_secondary) {
    return [];
  }

  return [
    branding.color_primary,
    branding.color_secondary,
    hexToComplimentary(branding.color_primary),
    hexToComplimentary(branding.color_secondary),
    '#000000',
    '#eeeeee',
    '#ffffff',
  ];
}

export default defaultColorPalette;



// WEBPACK FOOTER //
// ./src/mixins/colorPalette.js